// @ts-ignore
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data/sets/14/apple.json";
import { useEffect, useState } from "react";
import { conditions, getWebEnvConfig } from "helpers";
import { ConditionName, IEmojiPickerProps, IEmojiType, zIndex } from "interfaces";
import { getEmojiUrl } from "../../../../../services";

const EmojiPicker = ({ onClickOutside, setSelectedEmoji, parentClassName, emojiClassName, enableUnified }: IEmojiPickerProps) => {
    const [custom, setCustom] = useState<any>(undefined);

    useEffect(() => {
        const emojiPickerElement: any = document.getElementsByTagName("em-emoji-picker")[0];
        if (emojiPickerElement && !!emojiClassName && emojiClassName.length > 0)
            emojiClassName.map((item: string) => emojiPickerElement.classList.add(item));
        else if (emojiPickerElement)
            emojiPickerElement.classList.add(
                conditions(ConditionName.isTouchScreen) ? "pl-relative" : "pl-absolute",
                conditions(ConditionName.isTouchScreen) ? "pl-bottom-full" : "pl-top-[60px]",
                conditions(ConditionName.isTouchScreen) ? "pl-w-screen" : `pl-w-[500px]`,
                "pl-right-0",
                conditions(ConditionName.isTouchScreen) ? "pl-h-[250px]" : "pl-h-[350px]"
            );
    }, [custom]);

    useEffect(() => {
        if (enableUnified) {
            fetch(`${getWebEnvConfig("emojisBaseUrl")}config.json`)
                .then((response) => response.json())
                .then((data) => {
                    setCustom(
                        data.emjMart.map((item: any) => {
                            return {
                                id: item.id,
                                name: item.name,
                                emojis: item.emojis.map((item: any) => ({
                                    id: item.name,
                                    name: item.name,
                                    keywords: [item.name, ...item.keywords],
                                    skins: [{ src: `${getWebEnvConfig("emojisBaseUrl")}${item.name}.png`, unified: item.name }]
                                }))
                            };
                        })
                    );
                })
                .catch(() => setCustom([]));
        } else setCustom([]);
    }, []);

    return (
        <div className={`pl-w-full pl-flex pl-items-center pl-justify-center !pl-absolute ${parentClassName}`} style={{ zIndex: zIndex.emojiPicker }}>
            {custom && (
                <Picker
                    theme={conditions(ConditionName.isDarkMode) ? "dark" : "light"}
                    i18n={{
                        rtl: true,
                        search: "جستجو",
                        search_no_results_1: "اوه نه!",
                        search_no_results_2: "این ایموجی بافت نشد",
                        pick: "یک ایموجی انتخاب کنید",
                        add_custom: "ایموجی سفارشی اضافه کنید",
                        categories: {
                            activity: "فعالیت",
                            custom: "سفارشی",
                            flags: "پرچم ها",
                            foods: "غذا و نوشیدنی",
                            frequent: "پر استفاده ها",
                            nature: "حیوانات و طبیعت",
                            objects: "اشیاء",
                            people: "شکلک ها و مردم",
                            places: "سفر و مکان ها",
                            search: "نتایج جستجو",
                            symbols: "نمادها"
                        },
                        skins: {
                            choose: "رنگ پوسته پیش فرض را انتخب کنید",
                            "1": "پیش فرض",
                            "2": "روشن",
                            "3": "میانه-روشن",
                            "4": "میانه",
                            "5": "میانه تاریک",
                            "6": "تاریک"
                        }
                    }}
                    skinTonePosition="none"
                    data={data}
                    onEmojiSelect={(emoji: IEmojiType) => {
                        if (enableUnified) setSelectedEmoji(emoji.unified!);
                        else setSelectedEmoji(emoji.native!);
                    }}
                    getSpritesheetURL={() => `${getEmojiUrl()}/all.png`}
                    perLine={9}
                    custom={custom}
                    set={enableUnified ? "apple" : ""}
                    navPosition={"none"}
                    onClickOutside={onClickOutside}
                    dynamicWidth={true}
                />
            )}
        </div>
    );
};

export default EmojiPicker;
